var map = {
	"./dianshang.png": 5967,
	"./dianshang2.png": 6797,
	"./lianjie.png": 3380,
	"./lianjie2.png": 5212,
	"./pinpai.png": 2659,
	"./pinpai2.png": 1353,
	"./yingxiao.png": 76,
	"./yingxiao2.png": 548,
	"./zhixing.png": 132,
	"./zhixing2.png": 7429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7093;